import React from 'react';
import classes from "./Input.module.scss";

export const Input = ({ type, placeholder, name, value, onChange, idx }) => {
    return (
        <input type={type} placeholder={placeholder} className={classes.Input} value={value} name={name} data-idx={idx} onChange={(event) => onChange(event)}/>
    )
}